import api from '@/apis/di/fixedAssetAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';
import RefType from '@/commons/wildcards/constants/RefType.js';
import FilterOperator from '@/commons/wildcards/constants/FilterOperator.js';
import { ModuleFixedAsset } from '@/stores/moduleConst';

// Combo grid tài sản cố định
export const useFixedAssetComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { extendFilter } = usefilterActionCombo();
  const { proxy } = getCurrentInstance();

  // func call api lấy dữ liệu combo
  const onFixedAssetComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'fixed_asset_code';
    let ors = [];
    let extend = [];

    //Các ref_type lấy TSCĐ đã ghi tăng
    let incrementRefs = [
      RefType.FASaleInvoice,
      RefType.CAReceiptFixedAsset,
      RefType.BADepositFixedAsset,
      RefType.SAInvoice,
    ];

    //Các ref_type lấy TSCĐ chưa ghi tăng
    let notIncrementRefs = [
      RefType.BUTransferFixedAsset,
      RefType.CAPaymentFixedAsset,
      RefType.BAWithDrawFixedAsset,
      RefType.FAIncrement,
      RefType.FAPurchaseInvoice,
    ];

    //Các ref_type lấy TSCĐ đã ghi tăng và chưa ghi giảm tính đến thời điểm hạch toán
    let incrementAndNotDecrementRefs = [RefType.FADecrement, RefType.FATransfer];
    //Các ref_type lấy TSCĐ đã ghi tăng và chưa ghi giảm
    let incrementAndNotDecrementCustom = [RefType.FAAdjustment];
    //Lấy ra key operator phù hợp với ref_type
    if (incrementRefs.find(x => x == proxy.model.ref_type)) {
      extend = [{ Operator: 'INCREMENT' }];
    } else if (notIncrementRefs.find(x => x == proxy.model.ref_type)) {
      extend = [{ Operator: 'NOT_INCREMENT' }];
    } else if (incrementAndNotDecrementRefs.find(x => x == proxy.model.ref_type)) {
      //Bổ sung điều kiện lấy các chứng từ ghi tăng và chưa ghi giảm trước ngày CT
      extend = [
        {
          Operator: 'INCREMENT_NOT_DECREMENT',
          Value: proxy.$ms.commonFn.getMoment(proxy.model.posted_date).format('YYYY-MM-DD'),
        },
      ];
    } else if (incrementAndNotDecrementCustom.find(x => x == proxy.model.ref_type)) {
      extend = [{ Operator: 'INCREMENT_NOT_DECREMENT_CUSTOM' }];
    }

    payload.filter = extendFilter(payload.filter, extend);
    payload.columns +=
      ',fixed_asset_category_id,fixed_asset_category_name,department_id,department_name,department_code,source_type,quantity,description,unit,production_year,made_in,serial_number,vendor_name,vendor_address,guarantee_duration,last_state,disposed_date,disposed_amount,disposed_reason,purchased_date,used_date,depreciation_date,increment_date,org_price,accum_depreciation_amount,remaining_amount,life_time,depreciation_rate,period_depreciation_amount,org_price_account,depreciation_account,capital_account,budget_chapter_code,budget_kind_item_code,budget_sub_kind_item_code,budget_item_code,budget_sub_item_code,debit_depreciation_account,is_fixed_asset_transfer,depreciation_value_caculated,depreciation_time_caculated,remaining_life_time,end_year,devaluation_date,devaluation_amount,devaluation_period,devaluation_life_time,devaluation_rate,period_devaluation_amount,accum_devaluation_amount,remaining_devaluation_life_time,end_devaluation_date,devaluation_debit_account,devaluation_credit_account,production_rate,budget_source_id,budget_source_name';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  /**
   * Lấy payload cho form tìm nhanh
   * @returns
   */
  const onFixedAssetComboboxPayload = () => {
    let ors = [];
    let extend = [];
    let payload = {};

    //Các ref_type lấy TSCĐ đã ghi tăng
    let incrementRefs = [
      RefType.FASaleInvoice,
      RefType.CAReceiptFixedAsset,
      RefType.BADepositFixedAsset,
      RefType.SAInvoice,
    ];

    //Các ref_type lấy TSCĐ chưa ghi tăng
    let notIncrementRefs = [
      RefType.BUTransferFixedAsset,
      RefType.CAPaymentFixedAsset,
      RefType.BAWithDrawFixedAsset,
      RefType.FAIncrement,
      RefType.FAPurchaseInvoice,
    ];

    //Các ref_type lấy TSCĐ đã ghi tăng và chưa ghi giảm tính đến thời điểm hạch toán
    let incrementAndNotDecrementRefs = [RefType.FADecrement, RefType.FATransfer];
    //Các ref_type lấy TSCĐ đã ghi tăng và chưa ghi giảm
    let incrementAndNotDecrementCustom = [RefType.FAAdjustment];
    //Lấy ra key operator phù hợp với ref_type
    if (incrementRefs.find(x => x == proxy.model?.ref_type)) {
      extend = [{ Operator: 'INCREMENT' }];
    } else if (notIncrementRefs.find(x => x == proxy.model?.ref_type)) {
      extend = [{ Operator: 'NOT_INCREMENT' }];
    } else if (incrementAndNotDecrementRefs.find(x => x == proxy.model?.ref_type)) {
      //Bổ sung điều kiện lấy các chứng từ ghi tăng và chưa ghi giảm trước ngày CT
      extend = [
        {
          Operator: 'INCREMENT_NOT_DECREMENT',
          Value: proxy.$ms.commonFn.getMoment(proxy.model?.posted_date).format('YYYY-MM-DD'),
        },
      ];
    } else if (incrementAndNotDecrementCustom.find(x => x == proxy.model.ref_type)) {
      extend = [{ Operator: 'INCREMENT_NOT_DECREMENT_CUSTOM' }];
    }

    payload.filter = extendFilter(payload.filter, extend);
    return JSON.parse(payload.filter);
  };

  // config columns combo
  const fixedAssetComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã tài sản',
        dataField: 'fixed_asset_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài sản',
        dataField: 'fixed_asset_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'fixed_asset_code',
    valueField: 'fixed_asset_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'tài sản',
      payload: {
        sort: 'fixed_asset_code',
        filterFunc: onFixedAssetComboboxPayload,
      },
      module: ModuleFixedAsset,
      idField: 'fixed_asset_id',
    },
    isNotCopy: true,
    comboboxLoadData: onFixedAssetComboboxLoadData,
  };

  return {
    fixedAssetComboConfig,
    onFixedAssetComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
    onFixedAssetComboboxPayload,
  };
};
